import { HStack, VStack } from "@/components/Layout";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeInformationNavigation from "../../../-components/PersonProfileNavigation/EmployeeInformationNavigation";
import CommutingInformationSection from "../../../-components/PersonProfileSection/employee-information/CommutingInformationSection";
import EmployeeAssignmentSection from "../../../-components/PersonProfileSection/employee-information/EmployeeAssignmentSection";
import EmployeeContractSection from "../../../-components/PersonProfileSection/employee-information/EmployeeContractSection";
import EmployeePaymentMethodSection from "../../../-components/PersonProfileSection/employee-information/EmployeePaymentMethodSection";
import SocialInsuranceJapanSection from "../../../-components/PersonProfileSection/employee-information/SocialInsuranceJapanSection";
import IncomeTaxInfoSection from "../../../-components/PersonProfileSection/employee-information/TaxJapanSection/IncomeTaxInfoSection";
import ResidentTaxInfoSection from "../../../-components/PersonProfileSection/employee-information/TaxJapanSection/ResidentTaxInfoSection";
import WorkProfileSection from "../../../-components/PersonProfileSection/employee-information/WorkProfileSection";

export const Route = createFileRoute(
  "/_staff/person/$id/_profile/employee-information/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <HStack className="h-full">
      <nav className="sticky top-0 h-fit w-60 p-8">
        <EmployeeInformationNavigation />
      </nav>
      <div className="flex-1 overflow-y-auto p-8">
        <VStack className="w-full gap-4">
          <EmployeeContractSection />
          <EmployeeAssignmentSection />
          <WorkProfileSection />
          <SocialInsuranceJapanSection />
          <IncomeTaxInfoSection />
          <ResidentTaxInfoSection />
          <CommutingInformationSection />
          <EmployeePaymentMethodSection />
        </VStack>
      </div>
    </HStack>
  );
}
